import { RouterProvider } from 'react-router-dom';
import ThemeCustomization from 'themes';
import AntdThemeProvider from 'contexts/AntdThemeContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// material-ui
import router from 'routes';
import useAuth from 'hooks/Auth/useAuth';
import Loader from 'components/Loader';
// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => {
	const authChecked = useAuth();

	return !authChecked ? (
		<Loader />
	) : (
		<>
			<ThemeCustomization>
				<AntdThemeProvider style={{ height: '100%' }}>
					<RouterProvider
						router={router}
						future={{
							v7_startTransition: true,
						}}
					/>
				</AntdThemeProvider>
			</ThemeCustomization>
			<ToastContainer />
		</>
	);
};

export default App;
